export const pdfDisponible = (study) => !!(study && study.referenciaPdf)
